import React from "react";

export default function Discount({ fill = "#FAFAFA", width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.75 10.25L10.25 5.75L5.75 10.25Z' fill={fill} />
      <path
        d='M5.75 10.25L10.25 5.75'
        stroke={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.125 6.5C6.33211 6.5 6.5 6.33211 6.5 6.125C6.5 5.91789 6.33211 5.75 6.125 5.75C5.91789 5.75 5.75 5.91789 5.75 6.125C5.75 6.33211 5.91789 6.5 6.125 6.5Z'
        fill={fill}
        stroke={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.875 10.25C10.0821 10.25 10.25 10.0821 10.25 9.875C10.25 9.66789 10.0821 9.5 9.875 9.5C9.66789 9.5 9.5 9.66789 9.5 9.875C9.5 10.0821 9.66789 10.25 9.875 10.25Z'
        fill={fill}
        stroke={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25C4.27208 1.25 1.25 4.27208 1.25 8C1.25 11.7279 4.27208 14.75 8 14.75Z'
        stroke={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
